import { render, staticRenderFns } from "./createLCQuote.vue?vue&type=template&id=6aaa076a&scoped=true&"
import script from "./createLCQuote.vue?vue&type=script&lang=js&"
export * from "./createLCQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaa076a",
  null
  
)

export default component.exports